import React from 'react';
import { Dictionary } from 'underscore';

import { RemoteAgentPresenceIcon, RemoteAgentPresenceIconProps, RemoteAgentStateTextStrings } from '~src/app/content/RemoteAgentPresenceIcon';
import { Messages } from '~src/codegen/Localize';
import { IRemoteQueryAgent, RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

export function BridgeRemoteAgentsPresenceIcon(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[], poolTestId: string) {
  return (
    <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-connection-status-cell' + poolTestId}>
      {renderRemoteAgentPresenceIcon(agent, remoteAgentConnectionStatuses)}
    </span>
  );
}

function renderRemoteAgentPresenceIcon(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[]) {
  if (remoteAgentConnectionStatuses.length !== 0) {
    const status = getAgentStatus(agent, remoteAgentConnectionStatuses);
    if (status !== null) {
      const currentStateStringMap: Dictionary<string> = {};
      currentStateStringMap[RemoteAgentConnectionStatus.CONNECTED] = Messages.remoteAgentConnectionStatus_connected_short();
      currentStateStringMap[RemoteAgentConnectionStatus.DISCONNECTED] = Messages.remoteAgentConnectionStatus_disconnected_short();
      currentStateStringMap[RemoteAgentConnectionStatus.NEEDS_UPGRADE] = Messages.remoteAgentConnectionStatus_needsUpgrade_short();
      currentStateStringMap[RemoteAgentConnectionStatus.NOT_IN_SERVICE_MODE] = Messages.remoteAgentConnectionStatus_notInServiceMode_short();
      currentStateStringMap[RemoteAgentConnectionStatus.NOT_RESPONSIVE] = Messages.remoteAgentConnectionStatus_notResponding_short();
      currentStateStringMap[RemoteAgentConnectionStatus.THROTTLED] = Messages.remoteAgentConnectionStatus_throttled_short();


      const remoteAgentPresenceStrings: RemoteAgentStateTextStrings = {
        stateTextConnected: Messages.remoteAgentConnectionStatus_connected(),
        stateTextNotConnected: Messages.remoteAgentConnectionStatus_disconnected(),
        stateTextNotInServiceMode: Messages.remoteAgentConnectionStatus_notInServiceMode(),
        stateTextNotResponsive: Messages.remoteAgentConnectionStatus_notResponding(),
        stateTextNeedsUpgrade: Messages.remoteAgentConnectionStatus_needsUpgrade(),
        stateTextThrottled: Messages.remoteAgentConnectionStatus_throttled()
      };

      const props: RemoteAgentPresenceIconProps = {
        currentState: status.connectionStatus,
        currentStateString: currentStateStringMap[status.connectionStatus],
        stateTextStrings: remoteAgentPresenceStrings,
      };

      return (<>
        <RemoteAgentPresenceIcon {...props} />
        {props.currentStateString}
      </>);
    }
  }

  return null;
}

export function getAgentStatus(agent: IRemoteQueryAgent, remoteAgentConnectionStatuses: IRemoteAgentConnectionStatus[]): IRemoteAgentConnectionStatus {
  for (let i = 0; i < remoteAgentConnectionStatuses.length; i++) {
    if (remoteAgentConnectionStatuses[i].agentName === agent.agentName) {
      return remoteAgentConnectionStatuses[i];
    }
  }
  return null;
}
